var a={TableWithLoaderWrapper:"TableWithLoaderHOC__TableWithLoaderWrapper-tWq",isLoading:"TableWithLoaderHOC__isLoading-ILT",opacityBlinking:"TableWithLoaderHOC__opacityBlinking-9UP"};export{a as default};
